import SelectMain from "./Select";

export { SelectMain };

export default SelectMain;
